/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetTransactionsOptions, GetTransactionsResponses } from '../types/GetTransactions'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Role-based date window: public callers are limited to the last month; authenticated callers may query up to the last six months. If `start` is omitted it defaults to the role-based minimum. If credentials are supplied but invalid, the request is rejected as unauthorized.
 * @summary Get a filtered, paginated list of transactions
 * {@link /v1/transactions}
 */
export function getTransactions<ThrowOnError extends boolean = true>(
  options: Options<GetTransactionsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetTransactionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/transactions',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTransactionsResponses, ThrowOnError>>,
  )
}
